import { useEffect, useRef, useState } from 'react';

/**
 * Debounce hook for expensive calculations
 * Prevents calculation spam on rapid input changes
 */
export const useDebounce = (value, delay = 300) => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
};

/**
 * Throttle hook for real-time feedback
 * Ensures minimum time between executions
 */
export const useThrottle = (callback, delay = 100) => {
  const lastRan = useRef(Date.now());

  return (...args) => {
    const now = Date.now();
    if (now - lastRan.current >= delay) {
      callback(...args);
      lastRan.current = now;
    }
  };
};
